import { AdditionalServiceData, BookableServiceData, Service, ServiceType } from '@mews-commander/data-access';
import { Interval, Option } from '@mews-commander/types';
import { LocalizedProperty, TimeUnitUtils } from '@mews/framework';

export type BookableService = Omit<Service, 'data'> & {
    data: {
        discriminator: ServiceType.Bookable;
        value: BookableServiceData;
    };
};

export const isBookableService = (service: Service): service is BookableService =>
    service.data.discriminator === ServiceType.Bookable;

export type AdditionalService = Omit<Service, 'data'> & {
    data: {
        discriminator: ServiceType.Additional;
        value: AdditionalServiceData;
    };
};
export const isAdditionalService = (service: Service): service is AdditionalService =>
    service.data.discriminator === ServiceType.Additional;

export const serviceToOption = (service: Service): Option => ({
    value: service.id,
    label: <LocalizedProperty property={service.names} />,
    disabled: false,
    inactive: false,
    indent: false,
    secondaryText: null,
});

export function getServiceOperationalInterval<T extends Interval>(
    objectWithInterval: T,
    service: BookableService,
    timezone: string
) {
    const timePart = TimeUnitUtils.timeUnitToDateTimePart(service.data.value.timeUnitPeriod);
    const { startOffset, endOffset } = service.data.value;

    return {
        firstTimeUnitStartUtc: TimeUnitUtils.getFirstTimeUnitStartUtc(
            objectWithInterval.startUtc,
            timezone,
            endOffset,
            timePart
        ),
        lastTimeUnitStartUtc: TimeUnitUtils.getLastTimeUnitStartUtc(
            objectWithInterval.endUtc,
            timezone,
            startOffset,
            timePart
        ),
    };
}
